// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import langFr from './i18n/langFr'
import langEn from './i18n/langEn'
import heatmap from 'heatmap.js'

import VDateRange from 'vuetify-daterange-picker'
import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'
import Auth from '@okta/okta-vue'

Vue.use(Vuetify, {
  lang: {
    locales: {
      langFr,
      langEn
    },
    current: localStorage.lang || 'langFr'
  }
})

Vue.use(VDateRange)

Vue.config.productionTip = false

Vue.prototype.$heatmap = heatmap

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js